import React from "react";
import { Heading1 } from "../../../../components/Headings/Headings";

const DisclaimerScreen = () => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col leading-loose text-neutral-900">
        {/* <p className="pb-1 text-2xl font-semibold">
          CLINICAL DASHBOARD WEBSITE DISCLAIMER
        </p> */}

        <Heading1 headingText={"Clinical Dashboard Website Disclaimer"} />

        <i className="py-1 mt-5">CD-DS-20230901</i>
        <i className="py-1">Effective starting: September 01, 2023</i>

        <p className="py-1">
          Welcome to the Dermi.ai Clinical Dashboard Demo Web App, accessible at{" "}
          <a
            className="text-blue-700 cursor-pointer"
            href="https://dashboard.dermi.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            dashboard.dermi.ai
          </a>{" "}
          (<b>“Clinical Dashboard Demo”</b>, <b>“us”</b>, <b>“we”</b>). This
          platform is for research and informational purposes only and it is not
          intended to provide diagnosis, treatment, or medical advice. Products,
          services, information, and other content provided in this Clinical
          Dashboard Demo, including information that may be provided on this
          Clinical Dashboard Demo directly or by linking to third-party websites
          are provided for informational purposes only. Please consult a
          physician or other healthcare professional regarding any medical or
          health related diagnosis or treatment options.{" "}
        </p>
        <p className="py-1">
          The Clinical Dashboard Demo does not ask for any personal health
          information, and we will not be liable if any medical or personal
          health information is shared. You represent that you will refrain from
          sharing any personal health information including information related
          to physical or mental health, providing of health care including the
          identification of a person as a provider of health care, payment or
          eligibility of health care, donation of any body part or bodily
          substance or derived from the testing or examination of any such body
          part or bodily substance, health care number or information that
          identifies an individual’s substitute decision-maker. We will not be
          liable for maintaining any such personal health information.{" "}
        </p>
        <p className="py-1">
          All services provided on or through the Clinical Dashboard Demo and
          the content are provided to you on an “as is” basis without warranties
          from us of any kind, either express or implied. We expressly disclaim
          all other warranties, express or implied, including without limitation
          implied warranties of merchantability, fitness for a particular
          purpose, title, and non-infringement. We do not represent or warrant
          or guarantee that the services or the content are accurate, complete,
          timely, secure, reliable, current, virus-free, or error-free, and
          expressly disclaims any warranty or representation as to the accuracy
          or proprietary character of the services or the content, or any
          portion thereof. While we strive to have an error-free and
          uninterrupted service, we do not guarantee the absence of
          interruptions, nor shall you hold us liable for any damage such
          interruptions may cause.{" "}
        </p>
        <p className="py-1">
          Any services provided through the Clinical Dashboard Demo might be
          inappropriate for your own situation or might be misinterpreted and we
          assume no responsibility for how you use such services. The content,
          the results and the informational services are provided to you for
          informational purposes only. The content, results and the
          informational services are not intended to be medical advice and are
          not a substitute for professional medical advice. We advise you to
          discuss any questions you may have regarding any content, results,
          informational services and/or the status of your health with a
          qualified healthcare physician or other healthcare provider prior to
          relying on such services. You are responsible for verifying any
          services you obtain from the Clinical Dashboard Demo before relying on
          it. There are inherent risks associated with the use of, reliance on
          or inappropriate reliance on or use of the services. Reliance upon the
          services or the content shall also be at your own risk.
        </p>
        <p className="py-1">
          We provide no assurances, guarantees or representations (express or
          implied) regarding the quality, reputation, integrity, responsibility,
          or actions (as applicable) of any produced results. Some jurisdictions
          do not allow the disclaimer, exclusion or limitation of certain
          warranties, liabilities, and damages, so some of the disclaimers,
          exclusions and limitations made here may not apply to you. In such
          jurisdictions, our warranties and liability will be limited to the
          fullest extent permitted by applicable law.
        </p>
        <p className="py-1">
          Furthermore, you acknowledge that you have read and agreed to our
          Terms of Use and Privacy Policy accessible at{" "}
          <a
            className="text-blue-700 cursor-pointer"
            href="https://dermi.ai/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            dermi.ai/terms
          </a>{" "}
          and{" "}
          <a
            className="text-blue-700 cursor-pointer"
            href="https://dermi.ai/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            dermi.ai/privacy-policy
          </a>{" "}
          in addition to the above disclaimer.{" "}
        </p>
      </div>
    </div>
  );
};

export default DisclaimerScreen;
